<template>
    <div v-if="sop" class="workers-sop-test">

        <div class="ram-header">
            <ram-viewer-header ref="ramViewerHeader" class="sop-header" :ramId="ramId" :showTimer="true" v-if="ramId"></ram-viewer-header>
            <!--<div class="sop-header">
                <h1 class="header-title">{{sop.sopTitle}}</h1>
                <div class="ram"><b>{{sop.reference}}.</b> Version {{sop.version}}. {{sop.description}}</div>
            </div>-->
            <div :class="getSopClass() + ' state'">{{sop.state}}</div>
        </div>
        <div class="sop-description">{{sop.sopDescription}}</div>
        <div class="sop-questions">
            <div class="sop-question" :key="index" v-for="(question, index) in sop.sopQuestions">
                <div class="question control-label">
                    {{question.order}}. {{question.question}}
                </div>
                <div class="answer">
                    <control-text v-if="isSopEditable" v-model="question.answer"></control-text>
                    <div v-else>{{question.answer}}</div>
                    <button v-if="!isSopEditable && question.isValid === false" type="button" class="ml-auto btn btn-sm btn-danger">No valid</button>
                    <button v-if="!isSopEditable && question.isValid === true" type="button" class="btn btn-sm btn-success">Valid</button>
                </div>
                <div class="comment" v-if="question.comment">
                    <div class="comment-label">comment:</div>
                    <div> {{question.comment}}</div>
                </div>
            </div>
        </div>

        <br/>
        <div v-if="!isSopEditable && sop && sop.employeeSignatureUser && sop.employeeSignatureDate" class="signature">Signed on {{tools.dates.formatDateTime(sop.employeeSignatureDate)}} by {{sop.employeeSignatureUser}}.</div>
        <div v-if="!isSopEditable && sop && sop.validationSignatureUser && sop.validationSignatureDate" class="signature">{{isRejected ? 'Rejected' : 'Validated'}} on {{tools.dates.formatDateTime(sop.validationSignatureDate)}} by {{sop.validationSignatureUser}}.</div>

        <div v-if="isReview" class="review-and-sign-box">
            <div class="control-label">Review &amp; Sign</div>
            <div class="review-message">
                Please, review your answers and sign the test. Once you send it to validation you will not be able to modify your answers.
                <br /><br />
                By signing this document I confirm that I have fully understood the
                contents of this document, the safe systems of work and risk
                assessments and I agree to work complying with them and not defer from them
                without prior written confirmation from the company management and QHSE
                department:

            </div>
            <br />

            <div class="signature-pad">
                <div cols="auto" class="signature">Signed on {{signedDateFormat}} by {{userName}}.</div>
                <div @mousemove="onMouseMoveSign">
                    <VueSignaturePad class="canvas" width="40rem" height="8rem" ref="signaturePad" />
                </div>
                <div class="header">
                    <span class="button" @click="clearSignature()">Clear</span>
                    <span class="button" @click="undoSignature()">Undo</span>
                </div>
            </div>
        </div>

        <div class="buttons">
            <button v-if="isSopEditable" type="button" class="btn btn-success btn-sm" @click="showSendToValidation">Send to Validation</button>
            <button v-if="isSopEditable" type="button" class="btn btn-secondary btn-sm" @click="goToSopsPage">Cancel</button>
            <button v-if="isSopEditable" type="button" class="btn btn-primary btn-sm" @click="save">Save Test</button>
            <button v-if="isRejected" type="button" class="btn btn-danger btn-sm" @click="tryAgain">Try Again</button>
            <button v-if="!isSopEditable && !isReview" type="button" class="btn btn-primary btn-sm" @click="goToSopsPage">Close</button>
            <button v-if="isReview" type="button" class="btn btn-secondary btn-sm" @click="cancelSendToValidation">Cancel</button>
            <button v-if="isReview" type="button" class="btn btn-primary btn-sm" @click="confirmSendToValidation">Confirm Send to Validation</button>
        </div>

    </div>
</template>
<script>
    import { mapState } from 'vuex';

    export default {
        data() {
            return {
                sop: null,
                isSigned: false,
                isReview: false,
            };
        },
        async mounted() {
            await this.getEmployeeSop();
        },
        async beforeRouteLeave(to, from, next) {
            await this.$refs.ramViewerHeader.routeLeave();
            next();
        },
        computed: {
            ...mapState('mywork', ['rams', 'keepRams', 'lastSearch']),
            ...mapState('security', ['userName']),
            isSopEditable() {
                return (!this.isReview && this.sop && (this.sop.state == 'ASSIGNED' || this.sop.state == 'IN PROGRESS'));
            },
            isRejected() {
                return (this.sop && this.sop.state == 'REJECTED');
            },
            sopTestId() {
                return this.$route.params.sopTestId;
            },
            ramId() {
                return this.$route.params.ramId;
            },
            allAnswersCompleted() {
                if (this.sop && this.sop.sopQuestions) {
                    for (var i in this.sop.sopQuestions) {
                        var question = this.sop.sopQuestions[i];
                        if (!question.answer) {
                            return false;
                        }
                    }
                    return true;
                }
                return false;
            },
            signedDate() {
                return $virtus.tools.dates.now();
            },
            signedDateFormat() {
                return $virtus.tools.dates.formatDateTimeLong(this.signedDate);
            },
        },
        methods: {
            goToSopsPage() {
                this.$router.push('/mywork/sop');
            },
            async getEmployeeSop() {
                var result = await this.$store.dispatch('mywork/getEmployeeSop', { ramId: this.ramId, sopTestId: this.sopTestId });
                if (result && result.sopQuestions) {
                    var questions = result.sopQuestions;
                    var answers = result.sopAnswers;
                    for (var i in questions) {
                        var question = questions[i];
                        var answer = (answers ? answers.find(a => a.sopQuestionId == question.id) : null);
                        if (answer) {
                            question.answer = answer.answer;
                            question.comment = answer.comment;
                            question.isValid = answer.isValid;
                        } else {
                            question.answer = null;
                            question.comment = null;
                            question.isValid = null;
                        }
                    }
                }
                this.sop = result;
            },
            getSopClass() {
                switch (this.sop.state) {
                    case 'ASSIGNED':
                        return 'assigned-sop';
                    case 'IN PROGRESS':
                        return 'in-progress-sop';
                    case 'PENDING VALIDATION':
                        return 'pending-sop';
                    case 'REJECTED':
                        return 'rejected-sop';
                    case 'COMPLETED':
                        return 'completed-sop';
                }
                return '';
            },
            async tryAgain() {
                var confirmed = await $virtus.tools.messages.confirm('Are you sure?', 'This action will delete current SOP test and create a new one, please confirm the action.', true);
                if (confirmed && confirmed.isConfirmed) {
                    var result = await this.$store.dispatch('mywork/tryAgainEmployeeSop', { sopTestId: this.sopTestId });
                    if (result) {
                        $virtus.tools.messages.showSaveOk('sop test', 'created');
                        this.goToSopsPage();
                    }
                }
            },
            async save() {
                var answers = this.getAnswers();
                await this.$refs.ramViewerHeader.routeLeave();
                var result = await this.$store.dispatch('mywork/saveEmployeeSop', { ramId: this.ramId, sopTestId: this.sopTestId, answers });
                if (result) {
                    $virtus.tools.messages.showSaveOk('sop test', 'saved');
                    this.goToSopsPage();
                }
            },

            getAnswers() {
                var answers = this.sop.sopQuestions.map((q) => { return { sopQuestionId: q.id, answer: q.answer }; });
                return answers;
            },

            showSendToValidation() {
                if (!this.allAnswersCompleted) {
                    $virtus.tools.messages.error('Empty answers', "You can't send to validation until all answers are completed.");
                } else {
                    this.isReview = true;
                }
            },
            cancelSendToValidation() {
                this.isReview = false;
            },
            async confirmSendToValidation() {
                var answers = this.getAnswers();
                var signatureImage = this.$refs.signaturePad.saveSignature();
                var model = {
                    ramId: this.ramId,
                    sopTestId: this.sopTestId,
                    answers,
                    signatureDate: this.signedDate,
                    base64Image: signatureImage.data
                };
                await this.$refs.ramViewerHeader.routeLeave();
                var result = await this.$store.dispatch('mywork/sendToValidationEmployeeSop', model);
                if (result) {
                    $virtus.tools.messages.showSaveOk('sop test', 'saved');
                    this.goToSopsPage();
                }
            },
            onMouseMoveSign() {
                this.isSigned = !this.$refs.signaturePad.isEmpty();
            },
            undoSignature() {
                this.$refs.signaturePad.undoSignature();
                this.isSigned = !this.$refs.signaturePad.isEmpty();
            },
            clearSignature() {
                this.$refs.signaturePad.clearSignature();
                this.isSigned = false;
            },
        }
    }
</script>
<style>

    .workers-sop-test .ram-header {
        display: flex;
        justify-content: space-between;
        padding: 0 !important;
        background-color: rgba(255,255,255,0.4);
        align-items: center;
        flex-wrap: wrap;
    }

    .workers-sop-test .ram-header div {
        padding: 5px 10px;
    }

    .workers-sop-test .ram-header .sop-header {
        flex-grow: 1;
    }

    .workers-sop-test .ram-header .header-title {
        font-weight: bolder;
    }

    .workers-sop-test .ram-header .state {
        display: flex;
        align-self: stretch;
        align-content: center;
        justify-content: center;
        flex-wrap: wrap;
        font-weight: bolder;
    }

    .workers-sop-test .sop-description {
        padding: 1rem 0;
    }

    .workers-sop-test .sop-question {
        background-color: rgba(255,255,255,0.4);
        border-radius: 0.5rem;
        margin-top: 1rem;
    }

    .workers-sop-test .sop-question .question {
        background-color: #8B9870;
        color: #F2F7E8;
        border-radius: 0.5rem 0.5rem 0 0;
        padding: 0.5rem;
    }

    .workers-sop-test .sop-question .answer .btn {
        padding: 0.1rem 0.4rem;
        font-size: x-small;
        margin-left: 0.4rem;
    }

    .workers-sop-test .sop-question .answer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.5rem;
    }

    .workers-sop-test .sop-question .control-text {
        width: 100%;
    }

    .workers-sop-test .sop-question .comment {
        padding: 0.5rem;
        font-size: x-small;
        background-color: rgba(255,255,255,0.4);
        border-radius: 0 0 0.5rem 0.5rem;
        display: flex;
        align-items: center;
    }

    .workers-sop-test .sop-question .comment .control-text,
    .workers-sop-test .sop-question .comment .control-text div,
    .workers-sop-test .sop-question .comment .control-text input {
        flex-grow: 1;
    }

    .workers-sop-test .sop-question .comment .comment-label {
        font-weight: bold;
        padding-right: 0.3rem;
    }

    .workers-sop-test .review-and-sign-box {
        background-color: rgba(255,255,255,0.4);
        border-radius: 0.5rem;
        padding: 0.25rem 1rem 1rem 1rem;
    }

    .workers-sop-test .review-message {
        width: 40rem;
        text-align: justify;
    }

    .workers-sop-test .signature {
        font-style: italic;
        font-size: x-small;
    }

    .workers-sop-test .assigned-sop {
        background-color: lightskyblue;
    }

    .workers-sop-test .in-progress-sop {
        background-color: darkseagreen;
    }

    .workers-sop-test .pending-sop {
        background-color: palegoldenrod;
    }

    .workers-sop-test .rejected-sop {
        background-color: lightcoral;
    }

    .workers-sop-test .completed-sop {
        background-color: lightgray;
    }

</style>
